import React, { useState } from 'react'
import {
    Col,
    Card,
    Button
} from "react-bootstrap";
import { FaUserLarge } from "react-icons/fa6";
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import IndividualResetPassword from './IndividualResetPassword';


const IndividualDetails = ({ verficationList }) => {
    const [showResetModal, setShowResetModal] = useState(false);

    return (
        <>
            <div className="row ">
                <Col lg={12} className="mb-3">
                    <Card style={{ height: "auto" }}>
                        <div className="d-lg-flex justify-content-between p-2">
                            <div className="mt-2">
                                <div className="d-flex mt-1">
                                    <div className="mx-2">
                                        <h4><FaUserLarge className="text-primary" /></h4>

                                    </div>
                                    <div className="mx-lg-2 d-flex">
                                        <div><h4>Name:</h4></div>
                                        <div className="mx-lg-1"><h4>{verficationList?.name_of_organization}</h4></div>
                                    </div>
                                </div>
                                <div className="mx-2 mt-1">
                                    <strong>Atom ID: </strong>
                                    <span>{verficationList?.atom_id || "Not assigned"}</span>
                                </div>
                            </div>
                            <div className="d-lg-flex align-items-start">
                                <div className="mx-2">
                                    <div className="mx-2">
                                        <strong>User Type</strong>
                                    </div>
                                    <Button className="bg-primary py-1">
                                    {
                                        verficationList?.user_category_type?.user_category_sub_types
                                            ?.find(cat => cat.id === verficationList.sub_category_type)
                                            ?.sub_category_name
                                        ?? verficationList?.user_category_type?.category_name
                                    }
                                    </Button>
                                </div>
                                {verficationList?.user_id && (
                                    <div className="mx-2">
                                        <Button
                                            variant="outline-danger"
                                            className="py-1"
                                            onClick={() => setShowResetModal(true)}
                                        >
                                            Reset Password
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                </Col>

                {verficationList?.user_id && (
                    <IndividualResetPassword
                        showResetModal={showResetModal}
                        setShowResetModal={setShowResetModal}
                        userId={verficationList.user_id}
                    />
                )}

                <Col lg={12} className="mb-3">
                    <Card style={{ height: "auto" }}>
                        <div className="d-lg-flex justify-content-between p-2">
                            <div className="mt-2">
                                <h4>
                                    <span className="mx-lg-2 text-danger">
                                        Current Status:{" "}
                                        <span
                                            style={{ color: getStatusColor(verficationList?.status) }}
                                        >
                                            {verficationList?.status && formatStatus(verficationList?.status)}
                                        </span>
                                    </span>
                                </h4>
                            </div>

                            <div className="count_wrap" style={{ lineHeight: "0px" }}>
                                <div>
                                    <h4>Attempt Count</h4>
                                </div>
                                <div className="text-center count_title">
                                    <strong> {verficationList?.attempt_count + 1}</strong>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>

            </div>
        </>
    )
}

export default IndividualDetails